export const PAGE_LABELS = {
  TITLE: "Workspaces",
  CREATE_WORKSPACE: "New Workspace",
} as const;

export const DIALOG_LABELS = {
  YES: "Yes",
  NO: "No",
} as const;

export const DELETE_DIALOG = {
  TITLE: "Delete Workspace",
} as const;

export const ARCHIVE_DIALOG = {
  TITLE: "Archive Workspace",
  MESSAGE: "Are you sure you want to archive this Workspace?",
  SPINNER: "Archiving...",
} as const;

export const UNARCHIVE_DIALOG = {
  TITLE: "Unarchive Workspace",
  MESSAGE: "Are you sure you want to unarchive this Workspace?",
  SPINNER: "Unarchiving...",
} as const;

export const LEAVE_DIALOG = {
  TITLE: "Leave Workspace",
  MESSAGE:
    "Are you sure you want to leave this workspace? You will not have access to any conversations and documents from this workspace once you leave.",
  SPINNER: "Leaving...",
} as const;

export const EMPTY_STATE_LABELS = {
  NO_WORKSPACES: "No workspaces yet.",
  MY_WORKSPACES_SUBTITLE: "Create one to get started.",
  SHARED_WITH_ME_SUBTITLE: "You haven't been added to any workspaces yet.",
  ARCHIVED_SUBTITLE: "No archived workspaces.",
  NO_SEARCH_RESULTS: "No results found.",
  NO_SEARCH_RESULTS_SUBTITLE: "Try a different search term.",
} as const;

export const TABS = {
  MY_WORKSPACES: "My Workspaces",
  SHARED_WITH_ME: "Shared With Me",
  ARCHIVED: "Archived",
} as const;

export type SortField = "name" | "updatedAt" | "createdAt";

export const SORT_FIELD_LABELS: Record<SortField, string> = {
  name: "Name",
  updatedAt: "Last Updated",
  createdAt: "Date Created",
};

export type TabValue = (typeof TABS)[keyof typeof TABS];
